module.exports = __webpack_public_path__ + "media/pages/assets/images/calendar/2020/january-1543c197b1d7a46cdbd2416b809c0628.png";